;(function () {
    function formatTime(value) {
        if (!Number.isFinite(value)) {
            return "0:00";
        }

        var minutes = Math.floor(value / 60);
        var seconds = Math.floor(value % 60);

        return minutes + ":" + String(seconds).padStart(2, "0");
    }

    function getPlayerBadge(article) {
        if (article.classList.contains("article--letter")) {
            return {
                label: "Letter",
                className: "content-type-badge content-type-badge--letter craftsmith-player__badge"
            };
        }

        if (article.classList.contains("article--interview")) {
            return {
                label: "Interview",
                className: "content-type-badge content-type-badge--interview craftsmith-player__badge"
            };
        }

        return {
            label: "Episode",
            className: "content-type-badge content-type-badge--newsletter craftsmith-player__badge"
        };
    }

    function initPlayer() {
        if (!document.body.classList.contains("post-template")) {
            return;
        }

        var article = document.querySelector(".article");
        var titleElement = document.querySelector(".article-title");

        if (!article || !titleElement) {
            return;
        }

        var authoredSource = document.querySelector(".craftsmith-audio-source[data-audio-url]");
        var nativeAudio = document.querySelector(".gh-content audio");
        var cardAudio = document.querySelector(".gh-content .kg-audio-card audio");

        var source = "";
        var title = titleElement.textContent.trim();

        if (authoredSource) {
            source = authoredSource.dataset.audioUrl || "";
            title = authoredSource.dataset.episodeTitle || title;
        } else if (nativeAudio && (nativeAudio.currentSrc || nativeAudio.src)) {
            source = nativeAudio.currentSrc || nativeAudio.src;
        } else if (cardAudio && (cardAudio.currentSrc || cardAudio.src)) {
            source = cardAudio.currentSrc || cardAudio.src;
        }

        if (!source) {
            return;
        }

        var badge = getPlayerBadge(article);
        var player = document.createElement("div");
        var audio = document.createElement("audio");
        var playButton = document.createElement("button");
        var meta = document.createElement("div");
        var badgeElement = document.createElement("span");
        var titleNode = document.createElement("div");
        var timeline = document.createElement("div");
        var progress = document.createElement("button");
        var progressBar = document.createElement("span");
        var times = document.createElement("div");
        var closeButton = document.createElement("button");

        player.className = "craftsmith-player";
        audio.preload = "metadata";
        audio.src = source;

        playButton.className = "craftsmith-player__play";
        playButton.type = "button";
        playButton.setAttribute("aria-label", "Play episode audio");
        playButton.textContent = "Play";

        meta.className = "craftsmith-player__meta";
        badgeElement.className = badge.className;
        badgeElement.textContent = badge.label;
        titleNode.className = "craftsmith-player__title";
        titleNode.textContent = title;

        timeline.className = "craftsmith-player__timeline";
        progress.className = "craftsmith-player__progress";
        progress.type = "button";
        progress.setAttribute("aria-label", "Seek through episode audio");
        progressBar.className = "craftsmith-player__progress-bar";
        times.className = "craftsmith-player__times";
        times.textContent = "0:00 / 0:00";

        closeButton.className = "craftsmith-player__close";
        closeButton.type = "button";
        closeButton.setAttribute("aria-label", "Close audio player");
        closeButton.textContent = "X";

        progress.appendChild(progressBar);
        timeline.appendChild(progress);
        timeline.appendChild(times);
        meta.appendChild(badgeElement);
        meta.appendChild(titleNode);
        player.appendChild(playButton);
        player.appendChild(meta);
        player.appendChild(timeline);
        player.appendChild(closeButton);
        player.appendChild(audio);
        document.body.appendChild(player);

        if (authoredSource) {
            authoredSource.hidden = true;
        }

        function syncPlayer() {
            var duration = audio.duration || 0;
            var progressValue = duration > 0 ? (audio.currentTime / duration) * 100 : 0;

            progressBar.style.width = progressValue + "%";
            playButton.textContent = audio.paused ? "Play" : "Pause";
            times.textContent = formatTime(audio.currentTime) + " / " + formatTime(duration);
        }

        playButton.addEventListener("click", function () {
            if (audio.paused) {
                audio.play();
            } else {
                audio.pause();
            }
        });

        progress.addEventListener("click", function (event) {
            if (!Number.isFinite(audio.duration) || audio.duration <= 0) {
                return;
            }

            var rect = progress.getBoundingClientRect();
            var ratio = (event.clientX - rect.left) / rect.width;
            var boundedRatio = Math.min(Math.max(ratio, 0), 1);

            audio.currentTime = boundedRatio * audio.duration;
        });

        closeButton.addEventListener("click", function () {
            audio.pause();
            player.classList.remove("is-visible");
            document.body.classList.remove("has-audio-player");
        });

        audio.addEventListener("loadedmetadata", syncPlayer);
        audio.addEventListener("timeupdate", syncPlayer);
        audio.addEventListener("play", syncPlayer);
        audio.addEventListener("pause", syncPlayer);
        audio.addEventListener("ended", syncPlayer);

        syncPlayer();

        window.setTimeout(function () {
            player.classList.add("is-visible");
            document.body.classList.add("has-audio-player");
        }, 500);
    }

    document.addEventListener("DOMContentLoaded", initPlayer);
})();
